<template>
  <div class="d-flex mg-t-20 check-card-outer">
    <div class="wd-50p">
    <!-- {{ userTaskId }} -->
      <card-buddy v-if="!hideCard && buddyUserTaskRdy" :title="cardTitle" 
      :userTaskId="buddyUserTaskId"
      :rateTaskId="todo?.id"

       class="mg-b-30"
      @on-user-info="$emit('on-user-info', $event)"></card-buddy>
      <div class="">
      
        <div
          role="button"
          @click="hideCheck || $route.name=='buddyAdminChecklist3Employee' ? goToBox(box) : activeBoxData = box"
          v-for="box in todo.boxList"
          :key="box.id"
          :class="
            `check-card-item ${hideCheck ? 'check-code-'+box.code : box.colorClass} tx-white d-flex align-items-center mg-b-20 rounded-20 pd-x-30 pd-y-15 bxs pos-relative`
          " style="z-index: 3;"
        >
        
          <div class="tx-semibold">{{ box.boxName }}</div>
          <div class="d-flex mg-l-auto tx-semibold">
            <div>Явц: {{ getBoxProgess(box) }}%</div>
            <div class="rounded-10"></div>
          </div>
          <div class="rounded bg-white-1 pd-x-10 pd-y-7 mg-l-10">
            <feather type="chevron-right" style=""></feather>
          </div>
          <!-- {{ box.id==activeBoxData.id }} -->

          <div v-if="box.id==activeBoxData.id" class="rect wd-15 ht-15 pos-absolute r--5" style="transform: rotate(45deg);"></div>
        </div>
      </div>
    </div>
    <div class="wd-50p pd-l-20">
      <div class="rounded-20">
        <div
          :class="
            `check-card-item ${hideCheck ? 'check-code-'+activeBoxData.code : activeBoxData.colorClass} text-white pd-x-20 pd-y-15 tx-semibold`
          "
          style="border-radius: 20px 20px 0 0"
        >
          {{ activeBoxData.boxName }}
        </div>
        <div
          class="bg-white pd-x-20 pd-y-15"
          style="border-radius: 0 0 20px 20px"
        >
          <div class="bd rounded-20 pd-x-20 pd-y-10">
            <div
              v-for="(check, i) in activeBoxData.checkList"
              :class="
                `${activeBoxData.checkList.length - 1 != i ? 'bd-b' : ''}`
              "
            >
              <div class="d-flex align-items-center">
                <div @click="completeCheck(check)" :role="!check.isDone? 'button':''" v-if="!hideCheck">
                  <feather
                    v-if="check.isDone"
                    type="check-circle"
                    class="tx-primary"
                    style="width: 22px; height: 22px;"
                  ></feather>
                  <feather
                    v-else
                    type="circle"
                    class=""
                    style="width: 22px; height: 22px; color: #AEB1BD"
                  ></feather>
                </div>
                <div
                  @click="activeCheckId = check.id"
                  class="pd-10 tx-semibold wd-100p"
                  role="button"
                >
                  {{ check.checkName }}
                </div>
                <div v-if="hideCheck" class="tx-semibold" v-html="`${check.progress.toFixed(1)}%`"></div>
                <feather v-else
                  @click="activeCheckId = check.id"
                  role="button"
                  class="mg-l-auto "
                  type="chevron-down"
                ></feather>
              </div>
              <div v-show="activeCheckId == check.id" class="pd-l-40 pd-b-10" >
                <div v-html="check.info"></div>
                <div v-show="check.note!=null && check.note!=''" class="mg-t-5 bg-gray-100 pd-l-10 pd-y-5"
                style="border-left: 2px solid rgba(72, 94, 144, 0.16)"><i>Тэмдэглэл: </i>{{ check.note }}</div>
              </div>
              
            </div>
            <div v-if="activeBoxData.info" class="bg-light rounded-10 pd-15">
              <div v-html="activeBoxData.info"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
import { request } from "@/api/all";

import "element-ui/lib/theme-chalk/index.css";
import { MessageBox, Message } from "element-ui";

import contstants from "@/constants";

import { hasOneOf } from "@/libs/tools";

export default {
  name: "checklistComponent",
  components: {
    MessageBox, Message,
    cardBuddy: () => ({
      component: import(
        "@/views/modules/lms/student/buddy/components/cardBuddy.vue"
      ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    userTaskId: {
      type: Number,
      default: () => null,
    },
    cardTitle:{
      type: String,
      default: () => 'Таны BUDDY ажилтан',
    },
    hideCard: {
      type: Boolean,
      default: () => false,
    },
    hideCheck: {
      type: Boolean,
      default: () => false,
    },
    propSummary:{
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      buddyUserTaskId: null,
      buddyUserTaskRdy: false,
      activeCheckId: 0,
      todo: {},
      activeBoxData: {},
      isDataFetched: false,
      buddyLevels: contstants.levels,
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    // Watch the $route object for changes
    '$route' (to, from) {
      this.init();
    }
  },
  methods: {
    getBoxProgess(box){
      let rv=0;
      rv= box.progress.toFixed(1);
      // if(box.progress!=undefined){
      //   if(parseFloat(box.progress)>0){
      //     console.log('box1', box.progress)
      //     rv= box.progress.toFixed(1);
      //   } 
      //   // else if(parseFloat(box.progress) !== 0.0){
      //   //   console.log('box2', box.progress)
      //   //   // rv= box.progress.toFixed(1);
      //   // }
      //    else {
      //     console.log('else of 0', box.progress)  
      //   }
      //   // rv= box.progress.toFixed(1);
      // }else{
      //   console.log('else of undefined')
      // }
      return rv;
    },
    goToBox(box){
      // this.$emit('on-update-prop', { departId: this.$route.params.id, boxCode: box.code})
      console.log('goToBox', box, this.$route.name=='buddyAdminChecklist3Employee');
      if(this.$route.name=='buddyAdminChecklist3Employee'){
        this.$router.push({
        name: 'buddyAdminChecklist3Employee',
          params:{
            id: this.$route.params.id,
            depart: this.$route.params.depart,
            code: box.code
          }
        });
      }else {
        this.$router.push({
          name: 'buddyAdminReportCheck',
          params: {
            id: this.$route.params.id, 
            code: box.code
          }
        });
      }
    },
    completeCheck(check){
      // alert('sdf');
      let _value= null;
      if(check.isDone ){
        // || this.$route.name=='buddyAdminChecklist3Employee'
        return;
      }
      MessageBox.prompt('', 'ТЭМДЭГЛЭЛ', {
        confirmButtonText: 'Хадгалах',
        cancelButtonText: 'Цуцлах',
        inputType: 'textarea',
        inputPlaceholder: 'Тэмдэглэлээ оруулна уу',
        inputValidator: (value) => {
          return true;
        }
      }).then(({ value }) => {
        _value= value;

        
        if(hasOneOf(this.$store.state.user.userInfo.access, ['lmsbuddyadmin']) ){
          if(value==null || value==''){
            Message.error("Тэмдэглэлээ оруулна уу.");
            return;
          }
        }

        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "Buddy/newbie/CompleteMyCheck" },
          data: {
            id: check.id,
            note: value
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            Message.success("Амжилттай дуусгалаа.");
            check.isDone= true;
            check.note= _value;
            this.updateBoxProgress();
          }
        });
      }).catch(() => {});
    },
    // updateBoxProgress(){
    //   this.toggleBodyClass("addClass", "dynamic-locker");
    //   request({
    //     api: { method: "POST", url: "Buddy/newbie/getBoxProgress" },
    //     data: {
    //       userId: this.$store.state.user.userId,
    //       boxId: this.activeBoxData.id,
    //     },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.toggleBodyClass("removeClass", "dynamic-locker");
    //     if(res!=false){
    //       this.todo.boxList = this.todo.boxList.map(box => 
    //         box.boxId === this.activeBoxData.id ? { ...box, progress: res.data.progress } : box
    //       );
    //       // console.log('getBoxPercent', res);
    //     }
    //   });
    // },
    updateBoxProgress() {
      this.toggleBodyClass("addClass", "dynamic-locker");

      request({
        api: { method: "POST", url: "Buddy/newbie/getBoxProgress" },
        data: {
          userId: this.$store.state.user.userId,
          boxId: this.activeBoxData.id,
        },
        store: this.$store,
      })
      .then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res) {
          const box = this.todo.boxList.find(box => box.id === this.activeBoxData.id);
          if (box) {
            box.progress = res.data.progress;
          }
        }
      })
      .catch((error) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        console.error('Error updating box progress:', error);
        // Optionally show an error message to the user
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    getFieldFromConstants(field, level){
      let rv='';
      if(this.buddyLevels.filter(x=>x.code==level.code).length ){
        rv= this.buddyLevels.filter(x=>x.code==level.code)[0][field];
      }
      console.log('rv', rv);
      return rv
    },
    init() {
      console.log('r1');
      let _url='Buddy/newbie/GetMyRecentTasks';
      let _dta={
        userTaskId: this.userTaskId
      };
      if(this.hideCheck) {
        // console.log('e1');
        _url= 'Buddy/Admin/GetCheckSummary';
        const bxe = this.$store.state.buddy.boxSummary.find(item => item.code === this.$route.params.code);
        if (bxe) {
          _dta={
            departId: this.$route.params.id, 
            boxCode: this.$route.params.code
          }
        } else if(this.$store.state.buddy.boxSummary.length){
          _dta={
            departId: this.$route.params.id, 
            boxCode: this.$store.state.buddy.boxSummary[0]['code']
          };
          // console.log('e3', _dta);
        }
        
      } else if(this.$route.name=='buddyAdminChecklist3Employee') {
        _url= 'Buddy/Admin/GetCheckSummary';
        const bxe = this.$store.state.buddy.boxSummary.find(item => item.code === this.$route.params.code);
        if (bxe) {
          _dta={
            newbieId: this.$route.params.id, 
            boxCode: this.$route.params.code
          };
        }else if(this.$store.state.buddy.boxSummary.length){
          _dta={
            newbieId: this.$route.params.id, 
            boxCode: this.$store.state.buddy.boxSummary[0]['code']
          };
        }

        // console.log('this.$route.params.code', this.$route.params.code)
        // console.log('this.$route.params.code', this.$store.state.buddy.boxSummary)
      }
      // console.log('url', _url, this.$route);
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: _url },
        data: _dta,
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // console.log('r2', _url, _dta, res);
          if(this.hideCheck || this.$route.name=='buddyAdminChecklist3Employee'){
            console.log('e4', res.data.list);
            this.todo.boxList= this.$store.state.buddy.boxSummary.map(box => ({
                id: box.code,
                code: box.code,
                boxName: box.boxName,
                progress: box.progress,
                checkList: res.data.list,
                // colorClass: this.getFieldFromConstants('bgColor', box)
            }));
            this.getActiveBox();
          } else {
            console.log('GetMyRecentTasks', res, _url)
            this.todo = res.data.todo;
            this.getActiveBox();
          }

          if(_url=='Buddy/newbie/GetMyRecentTasks'){
            this.buddyUserTaskId= res.data.todo.buddyUserTaskId;
          }else{
            this.buddyUserTaskId= this.userTaskId;
          }
          this.buddyUserTaskRdy= true;

          const colors = ["bg-yagaan", "bg-blue", "bg-pink", "bg-green"];
          this.todo.boxList.forEach((box, index) => {
            box.colorClass = colors[index % colors.length];
          });

          this.isDataFetched = true;
        }
      });
    },

    getActiveBox() {
      const activeBoxes = this.todo.boxList.filter((x) => x.isActive);
      // console.log('t1');
      if (activeBoxes.length > 0) {
        // console.log('t2');
        this.activeBoxData = activeBoxes[0];
      }
      // else{
      //   console.log('activeBoxes', activeBoxes, this.todo.boxList,this.$route.params.code,
      //   this.todo.boxList.filter(x=>x.code==this.$route.params.code).length > 0
      //   );
      // }
       else if (this.todo.boxList.filter(x=>x.code==this.$route.params.code).length > 0) {
        // console.log('t3', this.todo.boxList.filter(x=>x.code==this.$route.params.code)[0]);
        this.activeBoxData = this.todo.boxList.filter(x=>x.code==this.$route.params.code)[0];
      } else if (this.todo.boxList.length > 0) {
        this.activeBoxData = this.todo.boxList[0];
      }
    },
    
  },
};
</script>
<style lang="scss">
.bxs {
  color: white;
}
.bxs:nth-child(n + 1),
.bg-yagaan {
  background: linear-gradient(
    135.15deg,
    #9c14f2 2.15%,
    #9627dd 65.39%,
    #b255ec 98.4%
  );

  .rect{
    background: rgb(173 78 234);
  }
}
.bxs:nth-child(n + 2),
.bg-blue {
  background: linear-gradient(
    135.15deg,
    #33b7ff 2.15%,
    #17a0e2 65.39%,
    #17a0e2 98.4%
  );

  .rect{
    background: #17a0e2;
  }
}
.bxs:nth-child(n + 3),
.bg-pink {
  background: linear-gradient(
    135.15deg,
    #fd709a 2.15%,
    #e43055 65.39%,
    #f26e7a 98.4%
  );

  .rect{
    background: #f26e7a;
  }
}
.bxs:nth-child(n + 4),
.bg-green {
  background: linear-gradient(
    135.15deg,
    #34bdbd 2.15%,
    #12a0a1 65.39%,
    #37babc 98.4%
  );

  .rect{
    background: #37babc;
  }
}
.bxs:nth-child(n + 5),
.bg-green {
  background: linear-gradient(135.15deg, #3AC37A 2.15%, #33BF75 65.39%, #55EB9B 98.4%);

  .rect{
    background: #4fe495;
  }
}
</style>
